import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

const L = {
    nl: { privacy: "Privacyverklaring", terms: "Algemene voorwaarden", cookies: "Cookiebeleid", vat: "BTW" },
    fr: { privacy: "Déclaration de confidentialité", terms: "Conditions générales", cookies: "Politique de cookies", vat: "TVA" },
    en: { privacy: "Privacy policy", terms: "Terms & conditions", cookies: "Cookie policy", vat: "VAT" },
    es: { privacy: "Política de privacidad", terms: "Términos y condiciones", cookies: "Política de cookies", vat: "NIF-IVA" },
};

export default function SiteFooter() {
    const { i18n } = useTranslation();
    const lang = (i18n.language || "nl").slice(0, 2);
    const t = L[lang] || L.nl;
    const [info, setInfo] = useState({ company_name: "Social Factory", btw_number: "", email: "info@social-factory.be" });

    useEffect(() => {
        api.get("/public/company-info").then((r) => setInfo(r.data)).catch(() => {});
    }, []);

    return (
        <footer className="border-t border-zinc-100 py-10" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    <div className="text-xs text-zinc-500" data-testid="footer-company-info">
                        © {new Date().getFullYear()} {info.company_name}
                        {info.btw_number ? <> · {t.vat} {info.btw_number}</> : null}
                        {" · "}
                        <a href={`mailto:${info.email}`} className="hover:text-zinc-950 transition">{info.email}</a>
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-zinc-500">
                        <Link to="/privacy" className="hover:text-zinc-950 transition" data-testid="footer-privacy-link">{t.privacy}</Link>
                        <Link to="/voorwaarden" className="hover:text-zinc-950 transition" data-testid="footer-terms-link">{t.terms}</Link>
                        <Link to="/cookies" className="hover:text-zinc-950 transition" data-testid="footer-cookies-link">{t.cookies}</Link>
                        <span className="text-zinc-400">vastgoed.social-factory.be</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
